import React from 'react';
import { motion } from 'framer-motion';

const About = () => {
  const stats = [
    { value: '15+', label: 'Years of Excellence' },
    { value: '500+', label: 'Luxury Properties' },
    { value: '₹1000Cr+', label: 'Portfolio Value' },
    { value: '98%', label: 'Client Satisfaction' },
  ];

  return (
    <section id="about" className="py-20 md:py-32 px-6 md:px-12 lg:px-24 bg-background" data-testid="about-section">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Text Content */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <div className="inline-block mb-4">
              <span className="text-secondary text-sm font-medium tracking-widest uppercase">About Venara Estate</span>
            </div>
            <h2 className="font-playfair text-4xl lg:text-5xl font-bold text-primary mb-6 tracking-tight leading-tight">
              Redefining Luxury Real Estate Excellence
            </h2>
            <div className="space-y-4 text-muted-foreground leading-relaxed">
              <p>
                Venara Estate stands as a beacon of distinction in the luxury real estate landscape. With over
                a decade of experience, we specialize in curating extraordinary living experiences for High Net
                Worth Individuals and Ultra High Net Worth Individuals seeking second homes and premium residences.
              </p>
              <p>
                Our philosophy is rooted in understanding that luxury is not just about opulence—it's about
                finding spaces that resonate with your aspirations, lifestyle, and legacy. From Mumbai's iconic
                skyline to Alibaug's serene coastlines, Lonavala's misty hills to Dubai's architectural marvels,
                we connect discerning clients with properties that transcend the ordinary.
              </p>
              <p className="text-primary font-medium">
                We don't just sell properties. We craft stories of distinction.
              </p>
            </div>

            {/* CTA */}
            <div className="mt-8">
              <a
                href="/contact"
                data-testid="learn-more-cta"
                className="inline-block bg-primary text-primary-foreground hover:bg-[#1A3F30] px-8 py-6 font-manrope tracking-wide uppercase text-xs transition-all duration-300"
              >
                Discover Our Story
              </a>
            </div>
          </motion.div>

          {/* Image & Stats */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="space-y-8"
          >
            {/* Image */}
            <div className="relative overflow-hidden group">
              <img
                src="https://images.unsplash.com/photo-1666094383847-9fae5f90a3c6?crop=entropy&cs=srgb&fm=jpg&q=85"
                alt="Luxury Office Setting"
                className="w-full h-[400px] object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 border border-secondary/30 group-hover:border-secondary transition-colors duration-500" />
            </div>

            {/* Stats Grid */}
            <div className="grid grid-cols-2 gap-6">
              {stats.map((stat, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.6, delay: index * 0.1 }}
                  data-testid={`stat-${stat.label.toLowerCase().replace(/\s+/g, '-')}`}
                  className="bg-accent p-6 border border-secondary/20 hover:border-secondary transition-colors duration-500"
                >
                  <div className="font-playfair text-3xl font-bold text-primary mb-2">{stat.value}</div>
                  <div className="text-sm text-muted-foreground uppercase tracking-wide">{stat.label}</div>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;
